const makeCityFromSlug = (str) => {
  // HACK for Carmel-by-the-Sea
  if (str === "Carmel-by-the-Sea") {
    return str
  }
  if (str === "Baywood-Los-Osos") {
    return "Baywood-Los Osos"
  }
  return str.replace(/-/g, " ")
}

export default makeCityFromSlug
